import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import { PATHS } from "../../../constants/paths";
import { PromptTabs } from "../pages/PromptDetails";
import { checkRole } from "../../../hoc";

const AgentsPage = lazy(() => import("../Agents"));
const PersonasTab = lazy(() => import("../tabs/PersonasPromptsTab"));
const TokenPricingTab = lazy(() => import("../tabs/TokenPricingTab"));
const ReportingTab = lazy(() => import("../tabs/ReportingTab"));
const PersonaPromptDetails = lazy(() => import("../pages/PromptDetails"));
const PersonaPromptDetailsTab = lazy(
  () => import("../tabs/PersonaPromptDetailsTab")
);

const useAgentsRoutes = () => {
  const isAdmin = checkRole("mgmt_admin");
  return (
    <Route>
      <Route
        path={`${PATHS.Agents.Prompts.Path}/${PATHS.Agents.Prompts.Details.Path}`}
        element={<PersonaPromptDetails />}
      >
        <Route
          path={PATHS.Agents.Prompts.Details.Tabs.path}
          element={<PersonaPromptDetailsTab />}
        />
        <Route
          index
          element={<Navigate replace to={PromptTabs.PersonasTemplate} />}
        />
      </Route>
      <Route path={PATHS.Agents.Path} element={<AgentsPage />}>
        <Route
          path={PATHS.Agents.Tabs.Personas.Path}
          element={<PersonasTab />}
        />
        {isAdmin && (
          <Route
            path={PATHS.Agents.Tabs.TokenPricing.Path}
            element={<TokenPricingTab />}
          />
        )}
        <Route
          path={PATHS.Agents.Tabs.Reporting.Path}
          element={<ReportingTab />}
        />
        <Route
          index
          element={<Navigate replace to={PATHS.Agents.Tabs.Personas.Path} />}
        />
      </Route>
    </Route>
  );
};

export { useAgentsRoutes };
